// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page container ──────────────────────────────────── */

.legal-page {
  max-width: 820px;
  margin: 0 auto;
  padding: 56px 24px 96px;
  color: var(--color-text-primary);
}

/* ── Header ──────────────────────────────────────────── */

.legal-page__header {
  text-align: center;
  margin-bottom: 40px;
}

.legal-page__label {
  display: inline-block;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-accent-base);
  margin-bottom: 16px;
  padding: 5px 12px;
  border: 1px solid var(--color-accent-base);
  border-radius: 3px;
  opacity: 0.85;
}

.legal-page__title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
  font-size: clamp(2.4rem, 6vw, 3.4rem);
  line-height: 1.08;
  letter-spacing: -0.01em;
  margin: 0 0 12px;
}

.legal-page__title-em {
  font-style: italic;
  color: var(--color-accent-base);
}

.legal-page__updated {
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-secondary);
  margin: 0 0 20px;
}

.legal-page__intro {
  max-width: 560px;
  margin: 0 auto;
  font-size: 1.02rem;
  line-height: 1.65;
  color: var(--color-text-secondary);
}

/* ── Article card ────────────────────────────────────── */

.legal-page__article {
  border: 1px solid var(--color-border-input);
  border-radius: 18px;
  background: var(--color-bg-canvas-surface);
  box-shadow: var(--color-shadow-canvas-frame);
  padding: clamp(28px, 5vw, 56px);
}

/* ── Table of contents ───────────────────────────────── */

.legal-page__toc {
  border: 1px solid var(--color-border-input);
  border-radius: 12px;
  background: var(--color-bg-canvas-frame);
  padding: 20px 24px;
  margin-bottom: 44px;
}

.legal-page__toc-title {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-text-secondary);
  margin-bottom: 12px;
}

.legal-page__toc-list {
  margin: 0;
  padding: 0 0 0 18px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
  row-gap: 7px;
  font-size: 0.9rem;
}

.legal-page__toc-list li::marker {
  color: var(--color-accent-base);
  font-size: 0.82rem;
}

.legal-page__toc-list a {
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color 0.15s ease;
}

.legal-page__toc-list a:hover {
  color: var(--color-accent-base);
}

/* ── Sections ────────────────────────────────────────── */

.legal-page__section {
  scroll-margin-top: 96px;
}

.legal-page__section + .legal-page__section {
  margin-top: 40px;
  padding-top: 36px;
  border-top: 1px solid var(--color-border-input);
}

.legal-page__section-title {
  display: flex;
  align-items: baseline;
  gap: 14px;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
  font-size: 1.55rem;
  line-height: 1.2;
  margin: 0 0 16px;
}

.legal-page__section-number {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: var(--color-accent-base);
}

.legal-page__paragraph {
  font-size: 0.96rem;
  line-height: 1.75;
  color: var(--color-text-secondary);
  margin: 0 0 14px;
}

.legal-page__paragraph:last-child {
  margin-bottom: 0;
}

.legal-page__list {
  margin: 0 0 14px;
  padding-left: 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 0.96rem;
  line-height: 1.7;
  color: var(--color-text-secondary);
}

.legal-page__list li::marker {
  color: var(--color-accent-base);
}

/* ── Cross link footer ───────────────────────────────── */

.legal-page__cross-link {
  margin-top: 28px;
  text-align: center;
  font-size: 0.92rem;
  line-height: 1.6;
  color: var(--color-text-secondary);
}

.legal-page__cross-link p {
  margin: 0;
}

.legal-page__cross-link a {
  color: var(--color-accent-base);
  text-decoration: none;
}

.legal-page__cross-link a:hover {
  text-decoration: underline;
}

/* ── Responsive ──────────────────────────────────────── */

@media (max-width: 640px) {
  .legal-page {
    padding-top: 36px;
  }

  .legal-page__toc-list {
    grid-template-columns: 1fr;
  }

  .legal-page__section-title {
    font-size: 1.35rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/LegalPage.css"],"names":[],"mappings":"AAEA,2DAA2D;;AAE3D;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,2DAA2D;;AAE3D;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,2DAA2D;;AAE3D;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA,2DAA2D;;AAE3D;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,2DAA2D;;AAE3D;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mDAAmD;EACnD,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;EAClE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,2DAA2D;;AAE3D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2DAA2D;;AAE3D;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap');\n\n/* ── Page container ──────────────────────────────────── */\n\n.legal-page {\n  max-width: 820px;\n  margin: 0 auto;\n  padding: 56px 24px 96px;\n  color: var(--color-text-primary);\n}\n\n/* ── Header ──────────────────────────────────────────── */\n\n.legal-page__header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.legal-page__label {\n  display: inline-block;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--color-accent-base);\n  margin-bottom: 16px;\n  padding: 5px 12px;\n  border: 1px solid var(--color-accent-base);\n  border-radius: 3px;\n  opacity: 0.85;\n}\n\n.legal-page__title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n  font-size: clamp(2.4rem, 6vw, 3.4rem);\n  line-height: 1.08;\n  letter-spacing: -0.01em;\n  margin: 0 0 12px;\n}\n\n.legal-page__title-em {\n  font-style: italic;\n  color: var(--color-accent-base);\n}\n\n.legal-page__updated {\n  font-size: 0.82rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-text-secondary);\n  margin: 0 0 20px;\n}\n\n.legal-page__intro {\n  max-width: 560px;\n  margin: 0 auto;\n  font-size: 1.02rem;\n  line-height: 1.65;\n  color: var(--color-text-secondary);\n}\n\n/* ── Article card ────────────────────────────────────── */\n\n.legal-page__article {\n  border: 1px solid var(--color-border-input);\n  border-radius: 18px;\n  background: var(--color-bg-canvas-surface);\n  box-shadow: var(--color-shadow-canvas-frame);\n  padding: clamp(28px, 5vw, 56px);\n}\n\n/* ── Table of contents ───────────────────────────────── */\n\n.legal-page__toc {\n  border: 1px solid var(--color-border-input);\n  border-radius: 12px;\n  background: var(--color-bg-canvas-frame);\n  padding: 20px 24px;\n  margin-bottom: 44px;\n}\n\n.legal-page__toc-title {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--color-text-secondary);\n  margin-bottom: 12px;\n}\n\n.legal-page__toc-list {\n  margin: 0;\n  padding: 0 0 0 18px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 24px;\n  row-gap: 7px;\n  font-size: 0.9rem;\n}\n\n.legal-page__toc-list li::marker {\n  color: var(--color-accent-base);\n  font-size: 0.82rem;\n}\n\n.legal-page__toc-list a {\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.legal-page__toc-list a:hover {\n  color: var(--color-accent-base);\n}\n\n/* ── Sections ────────────────────────────────────────── */\n\n.legal-page__section {\n  scroll-margin-top: 96px;\n}\n\n.legal-page__section + .legal-page__section {\n  margin-top: 40px;\n  padding-top: 36px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.legal-page__section-title {\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n  font-size: 1.55rem;\n  line-height: 1.2;\n  margin: 0 0 16px;\n}\n\n.legal-page__section-number {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  color: var(--color-accent-base);\n}\n\n.legal-page__paragraph {\n  font-size: 0.96rem;\n  line-height: 1.75;\n  color: var(--color-text-secondary);\n  margin: 0 0 14px;\n}\n\n.legal-page__paragraph:last-child {\n  margin-bottom: 0;\n}\n\n.legal-page__list {\n  margin: 0 0 14px;\n  padding-left: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 0.96rem;\n  line-height: 1.7;\n  color: var(--color-text-secondary);\n}\n\n.legal-page__list li::marker {\n  color: var(--color-accent-base);\n}\n\n/* ── Cross link footer ───────────────────────────────── */\n\n.legal-page__cross-link {\n  margin-top: 28px;\n  text-align: center;\n  font-size: 0.92rem;\n  line-height: 1.6;\n  color: var(--color-text-secondary);\n}\n\n.legal-page__cross-link p {\n  margin: 0;\n}\n\n.legal-page__cross-link a {\n  color: var(--color-accent-base);\n  text-decoration: none;\n}\n\n.legal-page__cross-link a:hover {\n  text-decoration: underline;\n}\n\n/* ── Responsive ──────────────────────────────────────── */\n\n@media (max-width: 640px) {\n  .legal-page {\n    padding-top: 36px;\n  }\n\n  .legal-page__toc-list {\n    grid-template-columns: 1fr;\n  }\n\n  .legal-page__section-title {\n    font-size: 1.35rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
